import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function WinnerCountFormatter({ info }) {
  const { value: winners } = getInfo(info)

  return winners?.length || 0
}
